import { createAnimation } from '@ionic/vue';

const DESKTOP_BREAKPOINT = 768;
const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;
const isRTL = () => document.documentElement.dir === 'rtl' || document.dir === 'rtl';

export const customEnterAnimation = (baseEl: any) => {
  const root = baseEl.shadowRoot;

  const backdropAnimation = createAnimation()
    .addElement(root.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.01', '0.5');

  const fromTransform = isDesktop()
    ? `translateX(${isRTL() ? '-100%' : '100%'})`
    : 'translateY(100%)';

  const wrapperAnimation = createAnimation()
    .addElement(root.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, transform: fromTransform, opacity: '0' },
      { offset: 1, transform: 'translateX(0) translateY(0)',    opacity: '1' }
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(300)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};

export const customLeaveAnimation = (baseEl: any) => {
  const root = baseEl.shadowRoot;

  const backdropAnimation = createAnimation()
    .addElement(root.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.5', '0.01');

  const toTransform = isDesktop()
    ? `translateX(${isRTL() ? '-100%' : '100%'})`
    : 'translateY(100%)';

  const wrapperAnimation = createAnimation()
    .addElement(root.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, transform: 'translateX(0) translateY(0)', opacity: '1' },
      { offset: 1, transform: toTransform,    opacity: '0' }
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-in')
    .duration(250)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};